import { render } from "./VideoListItem.vue?vue&type=template&id=0fcf7a76"
import script from "./VideoListItem.vue?vue&type=script&lang=js"
export * from "./VideoListItem.vue?vue&type=script&lang=js"
script.render = render

export default script